import { render, staticRenderFns } from "./HomeBottomNav.vue?vue&type=template&id=276a556f&"
import script from "./HomeBottomNav.vue?vue&type=script&lang=js&"
export * from "./HomeBottomNav.vue?vue&type=script&lang=js&"
import style0 from "./HomeBottomNav.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports